module.exports = __webpack_public_path__ + "media/sweepstakes_and_promotions/Fastweb_Edvisors_590x170-a2d579ed.jpg";